module.exports = __webpack_public_path__ + "static/img/Role.42385e1.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/Role.png
// module id = aJpM
// module chunks = 1